import { useState } from 'react';
import Sidebar from './components/Sidebar';
import Dashboard from './pages/Dashboard';
import Inventory from './pages/Inventory';
import ForecastDetail from './pages/ForecastDetail';
import Reorder from './pages/Reorder';
import Analytics from './pages/Analytics';
import PromoCalendar from './pages/PromoCalendar';

export default function ForecastApp() {
  const [activePage, setActivePage] = useState('dashboard');
  const [selectedSku, setSelectedSku] = useState(null);

  const handleSelectSku = (sku) => {
    setSelectedSku(sku);
    setActivePage('forecast-detail');
  };

  const handleBackFromForecast = () => {
    setSelectedSku(null);
    setActivePage('inventory');
  };

  const renderPage = () => {
    switch (activePage) {
      case 'dashboard':
        return <Dashboard />;
      case 'inventory':
        return <Inventory onSelectSku={handleSelectSku} />;
      case 'forecasts':
        return <Inventory onSelectSku={handleSelectSku} />;
      case 'forecast-detail':
        return <ForecastDetail sku={selectedSku} onBack={handleBackFromForecast} />;
      case 'reorder':
        return <Reorder />;
      case 'analytics':
        return <Analytics />;
      case 'calendar':
        return <PromoCalendar />;
      default:
        return <Dashboard />;
    }
  };

  return (
    <div className="flex min-h-screen bg-gray-50">
      <Sidebar
        activePage={activePage}
        onPageChange={(page) => {
          setActivePage(page);
          setSelectedSku(null);
        }}
      />
      <main className="flex-1 p-8 overflow-auto">
        {renderPage()}
      </main>
    </div>
  );
}
